<app-personalized-dialog [loading]="loading">
    <div dialog-title>
        Edit User
    </div>

    <div dialog-content>
        <!-- Content Header estilo Wizard -->
        <div class="content-header mb-3">
            <div class="content-icon">
                <lucide-icon name="user" [size]="22" [strokeWidth]="2"></lucide-icon>
            </div>
            <div>
                <div class="content-title">User Account Details</div>
                <div class="content-subtitle">Update profile information, assigned role, and platform access</div>
            </div>
        </div>

        <form [formGroup]="formUpdateUser" autocomplete="off" ngNativeValidate (ngSubmit)="updateUser()"
            id="editUserForm">
            <div class="row g-2">
                <div class="col-md-6 mt-2">
                    <app-custom-input label="User Name" [control]="formUpdateUser?.get('name')"></app-custom-input>
                </div>
                <div class="col-md-6 mt-2">
                    <app-read-only-field variant="gray" [value]="formUpdateUser?.get('email')?.value"
                        label="User Email"></app-read-only-field>
                </div>
                <div class="col-md-6 mt-2">
                    <app-select label="Role" [control]="formUpdateUser?.get('role')" valueField="value" textField="name"
                        [source]="allRolesOptions" placeholder="Select Role"></app-select>
                </div>
                <div *ngIf="isSalesRep" class="col-md-6 mt-2">
                    <app-select label="Liquidation Type" [control]="formUpdateUser?.get('liquidation_type')"
                        valueField="code" textField="name" [source]="liquidationTypes" placeholder="Select Type"></app-select>
                </div>

                <!-- Account Access Card -->
                <div class="col-12 mt-3">
                    <div class="kite-section-card mb-0">
                        <div class="kite-section-title">
                            <span>Account Status</span>
                        </div>
                        <div class="d-flex align-items-center justify-content-between pt-1">
                            <div>
                                <div class="text-xs text-muted">Allow user to sign in and access system functions.</div>
                            </div>
                            <app-checkbox [isSwitch]="true" label="" [control]="formUpdateUser.get('active')"></app-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div dialog-actions>
        <div class="d-flex justify-content-end gap-2 w-100">
            <app-button type="button" variant="secondary" (onClick)="closeModal()">
                Cancel
            </app-button>
            <app-button type="submit" form="editUserForm" [disabled]="loading" variant="primary">
                {{ loading ? 'Updating...' : 'Update User' }}
            </app-button>
        </div>
    </div>
</app-personalized-dialog>